import { ConfigFn } from '@config/types'

const config = (({ lottoUrl }) =>
  ({
    baseUrl: `${lottoUrl}/lotto.json`,
  }) as const) satisfies ConfigFn

export default config
